/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FileDto model module.
 * @module model/FileDto
 * @version v1.0.0
 */
class FileDto {
    /**
     * Constructs a new <code>FileDto</code>.
     * @alias module:model/FileDto
     */
    constructor() { 
        
        FileDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FileDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FileDto} obj Optional instance to populate.
     * @return {module:model/FileDto} The populated <code>FileDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FileDto();

            if (data.hasOwnProperty('bookIsbn')) {
                obj['bookIsbn'] = ApiClient.convertToType(data['bookIsbn'], 'String');
            }
            if (data.hasOwnProperty('bookType')) {
                obj['bookType'] = ApiClient.convertToType(data['bookType'], 'String');
            }
            if (data.hasOwnProperty('extension')) {
                obj['extension'] = ApiClient.convertToType(data['extension'], 'String');
            }
            if (data.hasOwnProperty('filename')) {
                obj['filename'] = ApiClient.convertToType(data['filename'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('md5')) {
                obj['md5'] = ApiClient.convertToType(data['md5'], 'String');
            }
            if (data.hasOwnProperty('url')) {
                obj['url'] = ApiClient.convertToType(data['url'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Book Id
 * @member {String} bookIsbn
 */
FileDto.prototype['bookIsbn'] = undefined;

/**
 * Book Type
 * @member {String} bookType
 */
FileDto.prototype['bookType'] = undefined;

/**
 * File extension
 * @member {String} extension
 */
FileDto.prototype['extension'] = undefined;

/**
 * File name
 * @member {String} filename
 */
FileDto.prototype['filename'] = undefined;

/**
 * File id
 * @member {String} id
 */
FileDto.prototype['id'] = undefined;

/**
 * md5
 * @member {String} md5
 */
FileDto.prototype['md5'] = undefined;

/**
 * url
 * @member {String} url
 */
FileDto.prototype['url'] = undefined;






export default FileDto;

